module.exports = "/location-warning-31a261984c8fc1823d6859198f4c8fcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/LocationMarker/icons/location-warning.svg
// module id = 7uQU
// module chunks = 4